import { useMemo } from 'react';
import { ReactComponent as GoToIcon } from 'assets/icons/arrow-up-right.svg';
import IconButton from 'components/IconButton/IconButton';
import { ICON_BUTTON_SIZES } from 'constants/interfaces';
import { formatNotificationTime } from 'utils/dateFormatters';

import type INotificationItem from './interfaces/INotificationItem';

import styles from './sass/NotificationsModal.module.scss';

function NotificationItem({
  notification,
  onReadOneNotification,
  handleRedirectToTask,
}: INotificationItem) {
  const isRead = useMemo(() => Boolean(notification.readAt), [notification.readAt]);

  const timeString = useMemo(() => formatNotificationTime(notification.createdAt), [notification.createdAt]);

  const handleReadOneNotification = (id: number) => {
    if (!isRead) {
      onReadOneNotification(id);
    }
  };

  return (
    <div className={`${styles.notificationItem} ${isRead ? styles.read : styles.unread}`}>
      <div
        className={styles.notificationContent}
        onClick={() => handleReadOneNotification(notification.id)}
        role="button"
        tabIndex={0}
        onKeyDown={() => handleReadOneNotification(notification.id)}
      >
        <h4 className={styles.notificationTitle}>{notification.title}</h4>
        <p className={styles.notificationDescription}>{notification.description}</p>
        <span className={styles.notificationTime}>{timeString}</span>
      </div>
      <IconButton
        icon={<GoToIcon />}
        onClick={() => handleRedirectToTask(notification.targetId || 0)}
        size={ICON_BUTTON_SIZES.large}
        className={styles.arrowButton}
      />
    </div>
  );
}

export default NotificationItem;
